import { Injectable } from "@angular/core";
import { CanDeactivate } from "@angular/router";
import { DynamicDialogService } from "../Customer/dynamic-dialog/dynamic-dialog.service";
import { CanDeactivateComponent } from "src/app/can-deactivate/can-deactivate.component";
import { DynamicDialogRef } from "primeng/api";

export interface CanComponentDeactivate {
    saveData: boolean;
    componentHasChanged: boolean;
}

@Injectable()
export class CanDeactivateGuardService implements CanDeactivate<CanComponentDeactivate> {
    dialogRef: DynamicDialogRef;

    constructor(private dynamicDialogService: DynamicDialogService) { }

    canDeactivate(component: CanComponentDeactivate) {
        if (!component.saveData && component.componentHasChanged) {
            // Close existing guard dialog but do not route back
            if (this.dialogRef) {
                this.dialogRef.close(false);
            }

            // Close opened dialog if exists to prevent dynamicDialogService failure
            if (this.dynamicDialogService.getConfigData()) {
                this.dynamicDialogService.closeDialog();
            }

            this.dialogRef = this.dynamicDialogService.openDialog(CanDeactivateComponent, {
                header: "אזהרה",
                styleClass: "modal modal_type_confirm"
            });

            this.dialogRef.onClose.subscribe((result: boolean) => {
                this.dialogRef = null;
            });

            return this.dialogRef.onClose;
            // return confirm("אתה/את רוצה לעבור למסך אחר ללא שמירת נתונים?");
        }
        return true;
    }
}
